import i18next from "../../config/i18next";
import i18nSubscription from "./i18n/fr.json";
import ListSubscriptionPage from "./pages/list-subscription-page/list-subscription-page";

i18next.addResourceBundle("fr", "subscriptions", i18nSubscription);

const Subscriptions = { ListSubscriptionPage };

export default Subscriptions;
